import AppleIcon from './component.jsx'
export default AppleIcon
